export default class CampaignReports {
	constructor() {
		const Masonry = require('masonry-layout')

		this.container = document.querySelector('.single-campaigns .campaign-posts__reports')
		
		if(! this.container) return

		let msnry = new Masonry( this.container, {
			itemSelector: '.tile',
			columnWidth: '.tile',
			percentPosition: true,
			horizontalOrder: true,
			gutter: 32
		})
	}
}